var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToggleTick(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 42,
    viewBox: "0 0 41 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_10919_280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.5908 0V3.34358H20.6403V0H19.5908Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2962 35.8046L11.0303 35.6469L10.8764 35.9193L9.95985 37.5463L9.80592 37.8187L10.0718 37.9763L10.4496 38.2021L10.7155 38.3562L10.8694 38.0874L11.786 36.4569L11.9399 36.1845L11.674 36.0304L11.2962 35.8046Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.30946 10.0451L3.15553 10.3174L2.93863 10.7045L2.7847 10.9768L4.63884 12.077L4.90471 12.2311L5.05864 11.9588L5.27904 11.5717L5.42947 11.2994L5.16709 11.1453L3.30946 10.0451Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.5908 37.8688V41.2124H20.6403V37.8688H19.5908Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8764 5.29311L11.0303 5.56547L11.2962 5.40779L11.674 5.18202L11.9399 5.02434L11.786 4.75556L10.8694 3.12498L10.7155 2.85262L10.4496 3.0103L10.0718 3.23608L9.80592 3.39376L9.95985 3.66253L10.8764 5.29311Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.06214 29.2537L4.90821 28.9777L3.05058 30.0779L2.7847 30.232L2.93863 30.5044L3.15553 30.895L3.30946 31.1673L5.16709 30.0671L5.42947 29.913L5.27904 29.6407L5.06214 29.2537Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26397 21.1438V20.0687H0V21.1438H3.26397Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9522 11.5717L35.169 11.9588L35.323 12.2311L35.5889 12.077L37.1771 11.1345L37.4465 10.9768L37.2926 10.7045L37.0722 10.3174L36.9182 10.0451L35.0641 11.1453L34.7982 11.2994L34.9522 11.5717Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9672 20.0687V21.1438H40.2312V20.0687H36.9672Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3513 35.9193L29.1973 35.6469L28.9315 35.8046L28.5536 36.0304L28.2913 36.1845L28.4417 36.4569L29.3618 38.0874L29.5122 38.3598L30.1594 37.9763L30.4218 37.8187L30.2678 37.5463L29.3513 35.9193Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.5122 2.85262L29.3618 3.12498L28.4417 4.75556L28.2913 5.02434L28.5536 5.18202L28.9315 5.40779L29.1973 5.56547L29.3513 5.29311L30.2678 3.66253L30.4218 3.39376L30.1594 3.23608L29.5122 2.85262Z",
    fill: "#B18001"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5889 29.1354L35.323 28.9813L35.169 29.2501L34.9522 29.6407L34.7982 29.913L35.0641 30.0671L36.9182 31.1673L37.2926 30.5044L37.443 30.232L37.1771 30.0779L35.5889 29.1354Z",
    fill: "#B18001"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_10919_280",
    x: 0,
    y: 0,
    width: 40.2312,
    height: 41.7124,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_10919_280"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_10919_280",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToggleTick);
export default ForwardRef;